import React, {
  useMemo,
  useState,
  useEffect,
  useCallback
} from 'react';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import Tabs from 'devextreme-react/tabs';
import { formatMessage } from 'devextreme/localization';
import Layout from '../../containers/Layout';
import style from './pieceinfo.module.scss';
import InfoDetails from '../../components/InfoDetails';
import InfoMap from '../../components/InfoMap';
import InfoHistory from '../../components/InfoHistory';

const PieceInfo = ({
  match,
  getPieceDetails,
  userReducer: { id },
  pieceInfoReducer: { details },
  getMap,
  history
}) => {
  const [tabsState, setTabsState] = useState([
    {
      id: 'details',
      text: formatMessage('textInfoTab').detailsPiece
    },
    {
      id: 'map',
      text: formatMessage('textInfoTab').coordinatesTS
    },
    {
      id: 'history',
      text: formatMessage('textInfoTab').historyPiece
    }
  ]);
  /** Выбор вкладки по умолчанию */
  const [tabSelect, setTabSelect] = useState('details');
  const [pieceNumId, setPieceNumId] = useState(null);
  const [checkedTablistItems, setCheckedTablistItems] = useState([]);

  const checkedListItemsIsSameWithCurrent = useMemo(
    () =>
      !!(checkedTablistItems.length && checkedTablistItems.length > 1
        && checkedTablistItems.some((id) => String(id) === String(pieceNumId))),
    [checkedTablistItems, pieceNumId]
  );

  useEffect(() => {
    const checkedItems = JSON.parse(localStorage.getItem('checkedItems'))?.map((item) => String(item.pieceNumId)) || [];
    if (checkedItems && checkedItems.length) {
      setCheckedTablistItems(checkedItems);
    }
  }, []);

  useEffect(() => {
    if (checkedListItemsIsSameWithCurrent) {
      setTabsState([{
        id: 'details',
        text: formatMessage('textInfoTab').detailsPiece
      }])
    }
  }, [checkedListItemsIsSameWithCurrent])

  useEffect(() => {
    if (id && match && match.params && match.params.pieceNumId) {
      setPieceNumId(match.params.pieceNumId);
    }
    if (id && match && match.params && match.params.tab) {
      setTabSelect(match.params.tab);
    }
  }, [id, match]);

  useEffect(() => {
    if (pieceNumId) {
      getPieceDetails({ pieceNumId });
    }
  }, [getPieceDetails, pieceNumId]);

  useEffect(() => {
    if (details && details.deliveryId && details.invoice) {
      getMap({
        basebtdid: details.deliveryId,
        invoice: details.invoice
      });
    }
    if (details && details.freightOrder) {
      getMap({ freightOrder: details.freightOrder });
    }
  }, [details, getMap]);

  const onItemClick = useCallback((args) => {
    setTabSelect(args.itemData.id);
    if (match && match.params && match.params.pieceNumId) {
      history.push(`/info/${match.params.pieceNumId}/${args.itemData.id}`);
    }
  }, [history, match]);

  const itemTabs = useMemo(() => () => (
    <Tabs elementAttr={{ id: style.tabsItem }}
          items={tabsState}
          selectedItem={tabsState.filter((item) => item.id === tabSelect)[0]}
          onItemClick={onItemClick}
    />
  ), [tabsState, onItemClick, tabSelect]);

  const divMain = useMemo(() => {
    switch (tabSelect) {
      case 'details':
        return (
          <>
            <InfoDetails tabSelect={tabSelect} pieceNumId={pieceNumId} />
          </>
        );
      case 'map':
        return (
          <>
            <InfoMap tabSelect={tabSelect} />
          </>
        );
      case 'history':
        return (
          <>
            <InfoHistory tabSelect={tabSelect} />
          </>
        );
      default:
        return '';
    }
  }, [tabSelect, pieceNumId]);

  const toolbarRender = useMemo(() => (
    <Toolbar elementAttr={{ class: style.toolbar }}>
      <Item location="center" render={itemTabs} />
    </Toolbar>
  ), [itemTabs]);
  return (
    <Layout>
      <div className={style.containing}>
        <div className={style.head}>
          { toolbarRender }
        </div>
        <div
          className={`${style.main}  ${tabSelect === 'history' || tabSelect === 'details'
            ? style.mainNoPadding : ''}`}>
          { divMain }
        </div>
      </div>
    </Layout>
  );
};

export default React.memo(PieceInfo);
